/**
 * TanStack Router: /performance/radar
 *
 * Organization overview landing page for Radar de Desempenho.
 * Entry point for executives to see company-wide metrics.
 *
 * @see packages/web-apps/monutrack/docs/PERFORMANCE-RADAR-frontend-spec.md
 */
import { createFileRoute } from '@tanstack/react-router'
import { OrgOverviewPage } from '@/components/performance/radar/OrgOverviewPage'

/**
 * Route: /performance/radar/
 * Layout: _auth/performance/radar
 * Component: OrgOverviewPage
 */
export const Route = createFileRoute('/_auth/performance/radar/')({
  component: OrgOverviewPage,
})
